import React from "react";
import PropTypes from "prop-types";
import { RemoveModal } from "../../../../modals";

const DefineRolesAndShiftsModals = ({
  isEditMode,
  rolePendingRemoval,
  shiftPendingRemoval,
  paidTrainingRemoval,
  onCloseRoleRemoval,
  onConfirmRoleRemoval,
  onCloseShiftRemoval,
  onConfirmShiftRemoval,
  onClosePaidTrainingRemoval,
  onConfirmPaidTrainingRemoval,
  roleRemovalLabels,
  shiftRemovalLabels,
  paidTrainingModal,
  roleRemovalLockedNearEventStart,
}) => (
  <>
    {isEditMode && (
      <input type="hidden" name="mode" value="edit" readOnly />
    )}

    <RemoveModal
      open={rolePendingRemoval !== null}
      onClose={onCloseRoleRemoval}
      onConfirm={onConfirmRoleRemoval}
      title={roleRemovalLabels.title}
      message={
        roleRemovalLockedNearEventStart
          ? roleRemovalLabels.withinLaunchWindowMessage
          : roleRemovalLabels.message
      }
      confirmLabel={roleRemovalLabels.confirmLabel}
      confirmDisabled={roleRemovalLockedNearEventStart}
    />
    <RemoveModal
      open={shiftPendingRemoval !== null}
      onClose={onCloseShiftRemoval}
      onConfirm={onConfirmShiftRemoval}
      title={shiftRemovalLabels.title}
      message={shiftRemovalLabels.message}
      confirmLabel={shiftRemovalLabels.confirmLabel}
    />
    <RemoveModal
      open={paidTrainingRemoval !== null}
      onClose={onClosePaidTrainingRemoval}
      onConfirm={onConfirmPaidTrainingRemoval}
      title={paidTrainingModal.title}
      message={paidTrainingModal.message}
      confirmLabel={paidTrainingModal.confirmLabel}
    />
  </>
);

DefineRolesAndShiftsModals.propTypes = {
  isEditMode: PropTypes.bool,
  rolePendingRemoval: PropTypes.any,
  shiftPendingRemoval: PropTypes.any,
  paidTrainingRemoval: PropTypes.any,
  onCloseRoleRemoval: PropTypes.func.isRequired,
  onConfirmRoleRemoval: PropTypes.func.isRequired,
  onCloseShiftRemoval: PropTypes.func.isRequired,
  onConfirmShiftRemoval: PropTypes.func.isRequired,
  onClosePaidTrainingRemoval: PropTypes.func.isRequired,
  onConfirmPaidTrainingRemoval: PropTypes.func.isRequired,
  roleRemovalLabels: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    withinLaunchWindowMessage: PropTypes.string,
    confirmLabel: PropTypes.string,
  }).isRequired,
  shiftRemovalLabels: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    confirmLabel: PropTypes.string,
  }).isRequired,
  paidTrainingModal: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    confirmLabel: PropTypes.string,
  }).isRequired,
  roleRemovalLockedNearEventStart: PropTypes.bool,
};

DefineRolesAndShiftsModals.defaultProps = {
  isEditMode: false,
  rolePendingRemoval: null,
  shiftPendingRemoval: null,
  paidTrainingRemoval: null,
  roleRemovalLockedNearEventStart: false,
};

export default DefineRolesAndShiftsModals;
